import type { ThemeSummary } from './model/types';
import { type AwpDashboardResult, useAwpDashboard } from './useAwpDashboard';

export interface ThemeSummariesResult extends Pick<AwpDashboardResult, 'status' | 'error' | 'retry'> {
  /** The four themes in display order, once `status` is `ready`. */
  themes: ThemeSummary[] | undefined;
  outOfRangeTotal: number | undefined;
}

/**
 * The health theme strip's slice of the dashboard. Any number of components can call it: the visits and panel
 * queries are shared through the cache, so they're requested once.
 */
export function useThemeSummaries(memberId: string | undefined): ThemeSummariesResult {
  const { data, status, error, retry } = useAwpDashboard(memberId);
  return { themes: data?.themes, outOfRangeTotal: data?.outOfRangeTotal, status, error, retry };
}
